import { useEffect, useState } from "react";
import { getCityList } from "../services/area";
import { useAppSelector } from "./useAppSelector";
import _ from "lodash";

function filterOptions(cities: any) {
  const mappedCityOptions =
    cities.map((city: any) => ({ label: city?.name, value: city?._id })) || [];
  const uniqueOptionSet = new Set(mappedCityOptions);
  const filteredCityOptions = Array.from(uniqueOptionSet);
  return filteredCityOptions;
}

export function useCityOptions() {
  const cities = useAppSelector((state) => state.user.allcities);
  const [cityOptions, setCityOptions] = useState(filterOptions(cities));

  const fetchCityOptions = async () => {
    try {
      const response = await getCityList();
      setCityOptions(filterOptions(response));
    } catch (error) {
      console.log("Error while fetching city list!", error);
    }
  };

  useEffect(() => {
    if (cityOptions.length > 0) return;
    fetchCityOptions();
  }, []);

  return { cityOptions };
}
